export default __webpack_public_path__ + "static/media/water3.d41b43bf.jpg";